import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

const list = [
	{ name: 'Introduction', link: 'intro' },
	{ name: 'Environment', link: 'environment' },
	{ name: 'Promise Objects', link: 'promise' },
	{ name: 'Error Objects', link: 'error' },
	{ name: 'Authentication', link: 'auth' },
	{ name: 'Reference', link: 'reference' }
];

class SidebarDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select(event) {
		this.props.dispatch(push('/javascript-sdk/' + event.target.value));

	}

	render() {
		const ItemLinks = list.map((item, index) =>
			<option key={index} name={item.name} value={item.link}>{item.name}</option>
		);
		return (
			<div className='dropdown-container'>
				<select className='dropdown-list' onChange={this.select}>
					{ItemLinks}
				</select>
			</div>
		);
	}
}

SidebarDropdown.propTypes = {
	dispatch: PropTypes.func.isRequired
};

export default SidebarDropdown;


// WEBPACK FOOTER //
// ./src/components/javascript-sdk/SidebarDropdown.js